var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"back"},_vm._l((_vm.mainList),function(item,index){return _c('div',{key:index,staticClass:"main_con"},[_c('img',{class:_vm.$parent.watchClientWidth>600?'mainItem_img':'mainItem_img1',attrs:{"src":_vm.$parent.switchLanguage == 'zh' ? item.zhUrl : item.enUrl,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }